import { Fragment } from 'react';
import { VIEWS } from '../../new-feature-onboarding/constants/OnboardingConstants';
import NewFeatureTourStep from '../../new-feature-onboarding/components/NewFeatureTourStep';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const HandleNewFeatureTourStepAccess = hasCustomViewsAccess =>
// eslint-disable-next-line
({
  children
}) => {
  const message = hasCustomViewsAccess ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.new-feature-onboarding.unifiedInbox.views.hasPermissionsBody"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.new-feature-onboarding.unifiedInbox.views.lacksPermissionsBody"
  });
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(NewFeatureTourStep, {
      stepKey: VIEWS,
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.new-feature-onboarding.unifiedInbox.views.header"
      }),
      body: message,
      placement: "right bottom",
      children: children
    })
  });
};
HandleNewFeatureTourStepAccess.displayName = 'HandleNewFeatureTourStepAccess';
export default HandleNewFeatureTourStepAccess;